import type { TypeSafeTableColumns } from "@dealer-center/core-components";
import { Table } from "@dealer-center/core-components";
import type { colorInterface } from "@dealer-center/ddc-pages-vin-decode-interface";
import {
  useGetAutoDataColorsExterior,
  useGetAutoDataColorsInterior
} from "@dealer-center/ddc-pages-vin-decode-fetch";

interface AutoDataOptionsProps {
  vehicleId: string;
}

const columns: TypeSafeTableColumns<colorInterface> = [
  {
    title: "Name",
    dataIndex: "name"
  },
  {
    title: "Code",
    dataIndex: "code"
  },
  {
    title: "Normalized Name",
    dataIndex: "normalizedName"
  }
];
const pageSize = 100;
export const AutoDataColors = ({ vehicleId }: AutoDataOptionsProps) => {
  const { data: colorsExterior, isLoading: loadingExterior } =
    useGetAutoDataColorsExterior(vehicleId);
  const { data: colorsInterior, isLoading: loadingInterior } =
    useGetAutoDataColorsInterior(vehicleId);
  const tables = [
    {
      title: "Exterior",
      data: colorsExterior || [],
      loading: loadingExterior
    },
    {
      title: "Interior",
      data: colorsInterior || [],
      loading: loadingInterior
    }
  ];
  return (
    <div>
      <h3>Colors</h3>
      {tables.map(table => (
        <div key={table.title}>
          <h4>{table.title}</h4>
          <Table.Table
            columns={columns}
            currentPageSize={pageSize}
            data={table.data}
            dataDensity="small"
            displayFilter={true}
            displayPageSizeSelector={false}
            enablePagination={table.data.length > pageSize}
            highlightOnHover={false}
            isLoading={table.loading}
            sortableColumns={true}
          />
        </div>
      ))}
    </div>
  );
};
